import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentPage, showManageListingsLink, currentUser } = props;
  const classes = classNames(rootClassName || css.root, className);
  const userType = currentUser?.attributes?.profile?.publicData?.userType;

  const manageListingsTabMaybe = showManageListingsLink
    ? [
      {
        text: userType === "horse-owner" ? <FormattedMessage id="UserNav.yourHorses" /> : <FormattedMessage id="UserNav.yourListings" />,
        selected: currentPage === 'ManageListingsPage',
        linkProps: {
          name: 'ManageListingsPage',
        },
      },
    ]
    : [];

  const tabs = [
    ...manageListingsTabMaybe,
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    ...(userType === 'equi-pro'
      ? [
        {
          text: <FormattedMessage id="UserNav.accreditation" />,
          selected: currentPage === 'AccreditationPage',
          disabled: false,
          linkProps: {
            name: 'AccreditationPage',
          },
        },
      ]
      : []),
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.manageFavouriteListings" />,
      selected: currentPage === 'ManageFavouritesPage',
      disabled: false,
      linkProps: {
        name: 'ManageFavouritesPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default UserNav;
